import { Dispatch, SetStateAction, useState } from 'react'
import { Col, Form, InputGroup, } from 'react-bootstrap'
import { Customer } from '../../model/Customer'
import { isMobile } from 'react-device-detect';

export const FilterComponent : React.FC<{customersList : Customer[], 
    setCount : Dispatch<SetStateAction<number>>, 
    setFilteredCustomersList : Dispatch<SetStateAction<Customer[]>>,
    setPage : Dispatch<SetStateAction<number>>
}> = (props) => {

    const {customersList, setCount, setFilteredCustomersList, setPage} = props
    const [filter, setFilter] = useState<string>('')

    const handleFilter = (phrase : string) => {
        setPage(1)
        let tempFilteredCustomersList = customersList.filter(customer => (`${customer.firstName} ${customer.lastName} ${customer.childName}`)
        .toLocaleLowerCase().includes(phrase.toLowerCase()))

        setCount(Math.ceil(tempFilteredCustomersList.length/10))
        setFilteredCustomersList(tempFilteredCustomersList)
        setFilter(phrase)
    }

    return (
        <>
        {isMobile ?
        <>
        <InputGroup className="mb-1 p-0">
            <Form.Control
                value={filter}
                size="sm"
                placeholder="Filtruj po imieniu i nazwisku"
                aria-label="Filtruj po imieniu i nazwisku"
                aria-describedby="basic-addon2"
                onChange={(e) => handleFilter(e.target.value)}
            />
        </InputGroup>
        <button className='button-65-mobile mb-3' onClick={() => handleFilter('')}>
                Wyczyść
        </button>
        </>
        :
        <Col className='float-end text-end'>
            <InputGroup className="mb-3">
            <Form.Control
                value={filter}
                placeholder="Filtruj po imieniu i nazwisku rodzica lub dziecka"
                aria-label="Filtruj po imieniu i nazwisku rodzica lub dziecka"
                aria-describedby="basic-addon2"
                onChange={(e) => handleFilter(e.target.value)}
            />
            <button className='button-65' onClick={() => handleFilter('')}>
                Wyczyść
            </button>
            </InputGroup>
        </Col>
        }
        </>
        
         
    )
}